import React, { useContext, useState } from "react"
import { Badge, Button, Drawer, Empty, Tag, Tooltip, Spin } from "antd"
import { EyeOutlined, CheckOutlined } from "@ant-design/icons"
import { Bell } from "react-feather"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { useHistory } from "react-router-dom"
import { request } from "../../utils/config"
import { AuthContext } from "../../contexts/auth/AuthContext"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import hasPermission, { usePermission } from "../../utils/hasPermission"
import "./notificationsBell.less"
import i18n from "../../services/i18n"

// msg 395: bildirishnoma ustiga bosilganda tegishli sahifaga o'tsin.
// Har tur -> manzil. Key "type:id..." shaklida — kerak bo'lsa id ni ham beramiz.
const partnerTenant = () => { try { return Number(JSON.parse(localStorage.getItem("user") || "{}")?.tenantId || 1) > 1 } catch { return false } }
const currentUser = (): any => { try { return JSON.parse(localStorage.getItem("user") || "null") } catch { return null } }
// tog'a #3409: turi alohida ko'rsatilmagan bildirishnoma — backend yozgan bo'lim (RefType) bo'yicha ochiladi
const REF_ROUTE: Record<string, string> = {
  returnSale: "/returnSales", returnSales: "/returnSales", returnPurchase: "/returnPurchases", returnPurchases: "/returnPurchases",
  money: "/moneys", sale: "/sales", sales: "/sales", order: "/orders", orders: "/orders", orderToMain: "/orderToMain",
  factoryPurchase: "/factoryPurchases", factoryPurchases: "/factoryPurchases", showcase: "/showcases", customer: "/customers",
  shop: "/shops", counterparty: "/counterparties", debtReminder: "/counterparties", transfer: "/transfers",
  delivery: "/deliveries", deliveries: "/deliveries", chat: "/chat", wallet: "/wallet",
  partnerApplication: "/partnerApplications",   // tog'a #3563 2-qism
}
export function routeForNotif(it: any, user?: any): string | null {
  const id = String(it.key || "").split(":")[1] || ""
  switch (it.type) {
    // tog'a #2504: kunlik xulosa — tizim chatidagi «📊 Kunlik hisobot» suhbati (chat huquqi bo'lmasa — sozlamalar oynasi, «Показать»)
    case "digest":
      return hasPermission(user || currentUser(), "/chat") ? "/chat/-2" : "?settings=open"
    // tog'a #2884 (2026-09-26): tovar yangiliklari — «📢 Новинки» suhbati (chat huquqi bo'lmasa — tovarlar)
    case "news":
      return hasPermission(user || currentUser(), "/chat") ? "/chat/-3" : "/products"
    case "overdue":
    case "duesoon":
      // Kontragent qarzi -> kontragent kartasi (id bo'lsa filtr bilan)
      return id ? `/counterparties?highlight=${id}` : "/counterparties"
    case "lowstock":
    case "stagnant":
      return "/residues"                 // ombor qoldiqlari
    case "delivery":
      return "/deliveries"               // logistika
    case "contract":
      return "/declarant"                // shartnomalar (deklarant bo'limi)
    case "factoryship":
      return "/factoryPurchases"         // zavod zakazlari
    // tog'a 1071 (2026-09-04): ko'prik bildirishnomalari — hamkorda SAV qaytarishi = «Возврат закупки» (GR-hujjat),
    // kutilayotgan GS-zakupka = «Закупки», SAVda hamkor qaytarishi = «Возврат продажи»
    case "bridge_return":
      return "/returnPurchases"
    case "bridge_pending":
      return "/purchases"
    case "bridge_return_in":
      return "/returnSales"
    case "bridge_error":
      return "/sales"
    // tog'a #2484: bron hodisalari — hamkor tizimida o'z zakazlari, sotuvchida kiruvchi zakazlar
    case "order_reserve_expired":
    case "order_reserved":
    case "order_reserve_extended":
    case "order_reserve_released":
    case "order_reserve_sold":
      return partnerTenant() ? "/orderToMain" : "/orders"
    // tog'a 1794 (2026-09-13): zakaz javoblari — backend xabarining o'zi «документ поступил в раздел
    // «Закупки»» deydi; avval bu turlarga route yo'q edi va bildirishnoma bosilmasdi
    case "order_accepted":
      return "/purchases"
    case "order_rejected":
    case "order_from_supplier":
      return "/orderToMain"
    // toga #2067 (2026-09-14): havolasi yo'q edi — bosilganda hech narsa bo'lmasdi
    case "chat":
      return "/chat"
    case "order_route":         // tog'a #3149: zakaz skladchiga yo'naltirildi
    case "order_route_alert":
    case "order_from_tenant":
      return "/orders"
    case "sale_confirmed":
    case "sale_rejected":
      return "/sales"
    case "bridge_money":
      return "/moneys"
    case "order_cancelled":
      return partnerTenant() ? "/orderToMain" : "/orders"
    case "bridge_showcase":
      return "/showcases"
    // tog'a #2455 (2026-09-24): perevod xabarlari bosilganda hech narsa ochilmasdi
    // tog'a #3249: narx ruxsati so'rovi — «Продажи» → «Запросы цены» oynasi
    case "price_request_new":
    case "price_request_approved":
    case "price_request_rejected":
      return "/sales?priceRequests=1"
    case "transfer_request":   // tog'a #3151: zakaz qoldig'i — asosiy skladdan so'rov
    case "transfer_recount":   // tog'a #3248: skrytiy priyomda ko'p kiritildi
    case "transfer_edited":
    case "transfer_pending":
    case "transfer_sent":
    case "transfer_accepted":
    case "transfer_rejected":
    case "transfer_cancelled":
      return "/transfers"
    // 2026-09-29 (menejer qo'llanmasi auditi): naqd pul topshirish xabarlari bosilganda hech narsa ochilmasdi.
    // Qabul qiluvchi (kassa) — «Кошелёк» → «Наличные у менеджеров»; menejer — «Касса (Деньги)» → «Мои наличные»
    case "cash_handover":
      return hasPermission(user || currentUser(), "/wallet") ? "/wallet" : "/moneys"
    // tog'a #3409 (2026-10-04): yangi yorliq olgan turlarning manzili (qolganlari — quyida refType bo'yicha)
    case "debt_reminder":
    case "debt_overdue":
      return "/counterparties"
    case "bridge_return_confirmed":
    case "bridge_return_rejected":
      return "/returnPurchases"
    case "money_confirmed":
    case "money_rejected":
    case "money_correction":
      return "/moneys"
    case "order_transfer_ready":
    case "order_transfer_back":
      return "/orders"
    case "customer_broadcast":
      return "/customers"
    case "shop_pending":
      return "/shops"
    case "factory_purchase":
      return "/factoryPurchases"
    case "subscription_admin":
      return "/tenants"
    case "pick_ready":   // tog'a #3445/#3450: «Окно склада» (huquqi bo'lmasa — «Заказы»)
    case "pick_missing":
    case "pick_late":
      return hasPermission(user || currentUser(), "/warehouseDesk") ? "/warehouseDesk" : "/orders"
    // tog'a #3563 2-qism: «Новая заявка партнёра» — ariza kartasi (RefId = ariza id; lentada refId bo'lmasa — ro'yxat)
    case "partner_application": {
      const refId = Number(it.refId || 0)
      return refId > 0 ? `/partnerApplications?id=${refId}` : "/partnerApplications"
    }
    default:
      return REF_ROUTE[String(it.refType || "")] || null
  }
}

// tog'a #342 / katalog #6024: 🔔 toifalari — Продажи, Долги, Касса, Возвраты, Перемещения, Заявки, Доставка, Заказы, Склад, Чат и новости, Прочее.
// Avval turi bo'yicha, qolganlari bildirishnoma ochadigan bo'lim bo'yicha (routeForNotif bilan bir xil manba).
const NOTIF_CATS: { key: string; label: string }[] = [
  { key: "sales", label: i18n.t("ncSales", "Продажи") },
  { key: "debts", label: i18n.t("ncDebts", "Долги") },
  { key: "cash", label: i18n.t("ncCash", "Касса") },
  { key: "returns", label: i18n.t("ncReturns", "Возвраты") },
  { key: "transfers", label: i18n.t("ncTransfers", "Перемещения") },
  { key: "requests", label: i18n.t("ncRequests", "Заявки") },
  { key: "delivery", label: i18n.t("ncDelivery", "Доставка") },
  { key: "orders", label: i18n.t("ncOrders", "Заказы") },
  { key: "stock", label: i18n.t("ncStock", "Склад") },
  { key: "chat", label: i18n.t("ncChat", "Чат и новости") },
  { key: "other", label: i18n.t("ncOther", "Прочее") },
]
const SECTION_CAT: Record<string, string> = {
  "/sales": "sales", "/customers": "sales", "/counterparties": "debts", "/moneys": "cash", "/wallet": "cash",
  "/returnSales": "returns", "/returnPurchases": "returns", "/transfers": "transfers",
  "/partnerApplications": "requests", "/shops": "requests", "/tenants": "requests",
  "/deliveries": "delivery", "/orders": "orders", "/orderToMain": "orders", "/purchases": "orders", "/factoryPurchases": "orders", "/warehouseDesk": "orders",
  "/residues": "stock", "/showcases": "stock", "/products": "stock", "/chat": "chat",
}
export function notifCategory(it: any, user?: any): string {
  const t = String(it.type || "")
  if (t === "overdue" || t === "duesoon" || t.startsWith("debt_")) return "debts"
  if (t === "lowstock" || t === "stagnant") return "stock"
  if (t === "chat" || t === "news" || t === "digest") return "chat"
  if (t.startsWith("price_request")) return "requests"
  if (t === "transfer_request") return "requests"
  const to = routeForNotif(it, user)
  if (!to || !to.startsWith("/")) return "other"
  return SECTION_CAT["/" + (to.split(/[?#]/)[0].split("/")[1] || "")] || "other"
}

// Bildirishnomalar markazi (best practice):
// - Headerda qo'ng'iroqcha + o'qilmaganlar soni
// - Bosilganda o'ngdan katta Drawer
// - Har bildirishnomada "ko'zcha" — bosilsa o'qilgan bo'ladi, son kamayadi
// - "Hammasini o'qish" tugmasi; o'qilganlar xira ko'rinadi
// - Holat serverda har foydalanuvchi uchun alohida saqlanadi (mainAlertSeen)

const TYPE_LABEL: Record<string, { label: string; color: string }> = {
  overdue: { label: i18n.t("overdueDebt"), color: "red" },
  duesoon: { label: i18n.t("paymentDue"), color: "gold" },
  lowstock: { label: i18n.t("lowInStock"), color: "orange" },
  stagnant: { label: i18n.t("notForSale"), color: "purple" },
  delivery: { label: i18n.t("delivery"), color: "orange" },
  contract: { label: i18n.t("contract"), color: "gold" },
  factoryship: { label: i18n.t("factoryRequest"), color: "orange" },
  // Egasi (2026-09-02): «chat», «order_from_tenant» kod bo'lib chiqardi — tarjima
  chat: { label: i18n.t("chat"), color: "blue" },
  order_from_tenant: { label: i18n.t("notifNewOrder"), color: "green" },
  order_accepted: { label: i18n.t("notifOrderAccepted"), color: "green" },
  order_rejected: { label: i18n.t("notifOrderRejected"), color: "red" },
  // tog'a 849 (2026-09-03): sklad perevodi hodisalari
  transfer_pending: { label: i18n.t("notifTransferPending"), color: "gold" },
  transfer_accepted: { label: i18n.t("notifTransferAccepted"), color: "green" },
  transfer_cancelled: { label: i18n.t("notifTransferCancelled"), color: "red" },
  transfer_sent: { label: i18n.t("notifTransferSent", "Перемещение отправлено"), color: "cyan" },
  order_reserved: { label: i18n.t("notifReserved", "Бронь"), color: "purple" },
  order_reserve_extended: { label: i18n.t("notifReserveExtended", "Бронь продлена"), color: "purple" },
  order_reserve_released: { label: i18n.t("notifReserveReleased", "Бронь снята"), color: "default" },
  order_reserve_expired: { label: i18n.t("notifReserveExpired", "Бронь истекла"), color: "orange" },
  order_reserve_sold: { label: i18n.t("notifReserveSold", "Бронь → продажа"), color: "green" },
  transfer_rejected: { label: i18n.t("notifTransferRejected", "Перемещение отклонено"), color: "volcano" },
  price_request_new: { label: i18n.t("notifPriceReqNew", "Запрос цены"), color: "gold" },   // tog'a #3249
  price_request_approved: { label: i18n.t("notifPriceReqApproved", "Цена разрешена"), color: "green" },
  price_request_rejected: { label: i18n.t("notifPriceReqRejected", "Цена не разрешена"), color: "red" },
  transfer_recount: { label: i18n.t("notifTransferRecount", "Пересчёт перевода"), color: "volcano" },   // tog'a #3248
  transfer_request: { label: i18n.t("notifTransferRequest", "Заявка на перевод"), color: "gold" },   // tog'a #3151
  order_route: { label: i18n.t("orForwarded", "Направлено кладовщикам"), color: "magenta" },   // tog'a #3149
  order_route_alert: { label: "⏰ " + i18n.t("orAlertLbl", "Заказ не принят"), color: "red" },
  bridge_pending: { label: i18n.t("notifNewDocument"), color: "geekblue" },
  system: { label: i18n.t("notifSystem"), color: "default" },
  digest: { label: i18n.t("notifDigest", "Ежедневный отчёт"), color: "cyan" },
  news: { label: i18n.t("pnConvTitle"), color: "magenta" },
  // tog'a #3409 (2026-10-04): quyidagi turlar lentada xom kalit («debt_reminder», «return_confirmed», «bridge_return_in») bo'lib chiqardi.
  // Ro'yxat backenddagi BARCHA mainNotification turlaridan olingan (perf/notif_types_check.js tekshiradi).
debt_reminder: { label: i18n.t("nt_debt_reminder", "Напоминание о долгах"), color: "gold" },
  debt_overdue: { label: i18n.t("nt_debt_overdue", "Просроченный долг"), color: "red" },
  return_confirmed: { label: i18n.t("nt_return_confirmed", "Возврат подтверждён"), color: "green" },
  return_rejected: { label: i18n.t("nt_return_rejected", "Возврат отклонён"), color: "red" },
  bridge_return_in: { label: i18n.t("nt_bridge_return_in", "Возврат от партнёра"), color: "volcano" },
  bridge_return: { label: i18n.t("nt_bridge_return", "Возврат поставщику"), color: "volcano" },
  bridge_return_confirmed: { label: i18n.t("nt_bridge_return_confirmed", "Поставщик принял возврат"), color: "green" },
  bridge_return_rejected: { label: i18n.t("nt_bridge_return_rejected", "Поставщик отклонил возврат"), color: "red" },
  bridge_error: { label: i18n.t("nt_bridge_error", "Ошибка обмена с партнёром"), color: "red" },
  bridge_money: { label: i18n.t("nt_bridge_money", "Оплата на подтверждение"), color: "gold" },
  bridge_showcase: { label: i18n.t("nt_bridge_showcase", "Витрина"), color: "purple" },
  showcase: { label: i18n.t("nt_showcase", "Витрина"), color: "purple" },
  money_confirmed: { label: i18n.t("nt_money_confirmed", "Платёж подтверждён"), color: "green" },
  money_rejected: { label: i18n.t("nt_money_rejected", "Платёж отклонён"), color: "red" },
  money_correction: { label: i18n.t("nt_money_correction", "Исправление платежа"), color: "gold" },
  sale_confirmed: { label: i18n.t("nt_sale_confirmed", "Продажа подтверждена"), color: "green" },
  sale_rejected: { label: i18n.t("nt_sale_rejected", "Продажа отклонена"), color: "red" },
  order_cancelled: { label: i18n.t("nt_order_cancelled", "Заказ отменён / изменён"), color: "volcano" },
  order_from_supplier: { label: i18n.t("nt_order_from_supplier", "Заказ от поставщика"), color: "green" },
  order_transfer_ready: { label: i18n.t("nt_order_transfer_ready", "Заказ готов к продаже"), color: "green" },
  order_transfer_back: { label: i18n.t("nt_order_transfer_back", "Перевод по заказу не состоялся"), color: "volcano" },
  transfer_edited: { label: i18n.t("nt_transfer_edited", "Перемещение изменено"), color: "gold" },
  cash_handover: { label: i18n.t("nt_cash_handover", "Сдача наличных"), color: "cyan" },
  ai_credit: { label: i18n.t("nt_ai_credit", "Баланс AI"), color: "red" },
  customer_broadcast: { label: i18n.t("nt_customer_broadcast", "Рассылка клиентам"), color: "blue" },
  shop_pending: { label: i18n.t("nt_shop_pending", "Новый магазин"), color: "gold" },
  subscription_warning: { label: i18n.t("nt_subscription_warning", "Срок подписки"), color: "orange" },
  subscription_expired: { label: i18n.t("nt_subscription_expired", "Подписка истекла"), color: "red" },
  subscription_admin: { label: i18n.t("nt_subscription_admin", "Подписки"), color: "gold" },
  // tog'a #3975: abonent to'lovi
  abonent_start: { label: i18n.t("nt_abonent_start", "Абонентская плата"), color: "blue" },
  abonent_warning: { label: i18n.t("nt_abonent_warning", "Абонентская плата: срок"), color: "orange" },
  abonent_blocked: { label: i18n.t("nt_abonent_blocked", "Доступ приостановлен"), color: "red" },
  abonent_summary: { label: i18n.t("nt_abonent_summary", "Абонентская плата партнёров"), color: "gold" },
  factory_purchase: { label: i18n.t("nt_factory_purchase", "Закупка завода"), color: "orange" },
  // tog'a #3445/#3450: «Окно склада» xabarlari
  pick_ready: { label: i18n.t("nt_pick_ready", "Собрано на складе"), color: "purple" },
  pick_missing: { label: i18n.t("nt_pick_missing", "Нет на складе"), color: "red" },
  pick_late: { label: "⏰ " + i18n.t("nt_pick_late", "Склад: задержка"), color: "volcano" },
  partner_application: { label: i18n.t("nt_partner_application", "Заявка партнёра"), color: "geekblue" },   // tog'a #3563 2-qism
}

// 🔔 lentasi — qo'ng'iroq va menyu bo'lim badge'lari (useSectionBadges) BITTA kesh kalitini ulashadi (server yuki oshmaydi)
export const fetchAlertsFeed = async () => {
  const r = await request({ url: "Alerts/Feed" })
  return r.data
}
// PERF-01 (2026-09-03): har 60 soniyada + har oyna fokusida so’ralardi. Server tomonda
// bu so’rov eng og’ir hisoblarni (qarzlar + qoldiq, qoldiq IKKI marta) qayta yugurtirardi,
// shuning uchun tovar/kontragent soni o’sganda butun tizim sekinlashardi. Server endi
// 3 daqiqa keshlaydi; brauzer ham 3 daqiqada bir marta so’raydi va oyna fokusida
// qayta so’ramaydi (bir necha oyna ochiq bo’lsa bu yuk ko’payib ketardi).
export const ALERTS_FEED_OPTS = { refetchInterval: 180000, refetchOnWindowFocus: false, staleTime: 150000 }

export default function NotificationsBell() {
  const { authState } = useContext(AuthContext)
  // Egasi (2026-09-01): «har bir foydalanuvchini notificationlari o'ziga
  // kelsin… ochilmagani tepada, uydamleniyada tursin».
  // Ilgari qo'ng'iroq FAQAT «hisobot» huquqi borlarga ko'rinardi — ya'ni
  // kontragent va menejer o'ziga kelgan xabarni umuman ko'ra olmasdi.
  // Server allaqachon har kimga FAQAT o'ziniki beradi (Alerts/Feed —
  // boshqaruv bloki `reports` bilan alohida cheklangan), shuning uchun
  // qo'ng'iroqni hammaga ochish xavfsiz.
  const canRead = !!authState?.user
  const [open, setOpen] = useState(false)
  const [cat, setCat] = useState("")   // tog'a #342 / #6024: tanlangan toifa ("" = hammasi)
  const queryClient = useQueryClient()
  const history = useHistory()

  // Bildirishnoma ustiga bosilganda: o'qilgan qilinadi + tegishli sahifaga o'tiladi
  const openNotif = (it: any) => {
    if (!it.seen) markSeen(it.key)
    const to = routeForNotif(it, authState?.user)
    if (to) {
      setOpen(false)
      history.push(to)
    }
  }

  const { data, isLoading } = useQuery(["ALERTS_FEED"], fetchAlertsFeed, { enabled: !!canRead, ...ALERTS_FEED_OPTS })

  const { mutate: markSeen } = useMutation(
    async (key: string) => request({ url: "Alerts/Seen", method: "post", params: { key } }),
    { onSuccess: () => queryClient.invalidateQueries(["ALERTS_FEED"]) }
  )

  const { mutate: markAllSeen, isLoading: allLoading } = useMutation(
    async (keys: string[]) => request({ url: "Alerts/SeenAll", method: "post", data: keys }),
    { onSuccess: () => queryClient.invalidateQueries(["ALERTS_FEED"]) }
  )

  if (!canRead) return null

  const allItems: any[] = data?.items || []
  const unread = data?.unreadCount || 0
  // tog'a #342 / #6024: toifa filtri — faqat bor toifalar chip bo'lib chiqadi (soni = o'qilmaganlar, bo'lmasa jami)
  const catOf = (it: any) => notifCategory(it, authState?.user)
  const catStats = NOTIF_CATS.map((c) => {
    const inCat = allItems.filter((i) => catOf(i) === c.key)
    return { ...c, total: inCat.length, unseen: inCat.filter((i) => !i.seen).length }
  }).filter((c) => c.total > 0)
  const activeCat = cat && catStats.some((c) => c.key === cat) ? cat : ""
  const items: any[] = activeCat ? allItems.filter((i) => catOf(i) === activeCat) : allItems
  const unseenKeys = items.filter((i) => !i.seen).map((i) => i.key)

  return (
    <>
      <Tooltip placement="bottom" title={i18n.t("notifications")}>
        <Badge count={unread} size="small" className="hdr-badge" overflowCount={99}>
          <Button
            size="large"
            className="buttonHeader_r headermargin_r"
            onClick={() => setOpen(true)}
            icon={<Bell size={20} strokeWidth={2} />}
          />
        </Badge>
      </Tooltip>
      <Drawer
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>
              🔔 {i18n.t("notifications")} {unread > 0 && <Tag color="red">{unread}</Tag>}
            </span>
            {unseenKeys.length > 0 && (
              <Button
                size="small"
                icon={<CheckOutlined />}
                loading={allLoading}
                onClick={() => markAllSeen(unseenKeys)}
              >
                {i18n.t("readAll", "Прочитать все")}
              </Button>
            )}
          </div>
        }
        placement="right"
        width={Math.min(480, window.innerWidth)}
        visible={open}
        onClose={() => setOpen(false)}
        bodyStyle={{ padding: "8px 12px" }}
      >
        {catStats.length > 1 && (
          <div className="notif-cats" data-testid="notif-cats" style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: "4px 0 10px" }}>
            <Tag.CheckableTag checked={!activeCat} onChange={() => setCat("")}>
              {i18n.t("all", "Все")} {allItems.length}
            </Tag.CheckableTag>
            {catStats.map((c) => (
              <Tag.CheckableTag key={c.key} checked={activeCat === c.key} onChange={() => setCat(activeCat === c.key ? "" : c.key)}>
                {c.label} {c.unseen > 0 ? <b style={{ color: activeCat === c.key ? undefined : "#ef4444" }}>{c.unseen}</b> : <span style={{ opacity: 0.6 }}>{c.total}</span>}
              </Tag.CheckableTag>
            ))}
          </div>
        )}
        {isLoading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin />
          </div>
        ) : items.length === 0 ? (
          <Empty description={i18n.t("noNotifications")} style={{ marginTop: 60 }} />
        ) : (
          items.map((it) => {
            const meta = TYPE_LABEL[it.type] || { label: i18n.t("nt_notification", "Уведомление"), color: "default" }   // #3409: noma'lum tur — xom kalit emas
            return (
              <div key={it.key} className={`notif-item ${it.seen ? "seen" : ""}`}>
                <div
                  className="notif-body"
                  style={{ cursor: routeForNotif(it) ? "pointer" : "default" }}
                  onClick={() => openNotif(it)}
                >
                  <div className="notif-top">
                    <Tag color={meta.color}>{meta.label}</Tag>
                    <b className="notif-title">{it.title}</b>
                  </div>
                  <div className="notif-text">{it.text}</div>
                </div>
                {!it.seen && (
                  <Tooltip title={i18n.t("read")}>
                    <Button
                      type="text"
                      className="notif-eye"
                      icon={<EyeOutlined />}
                      onClick={() => markSeen(it.key)}
                    />
                  </Tooltip>
                )}
              </div>
            )
          })
        )}
      </Drawer>
    </>
  )
}
